import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import {
	MerchantSearch,
	IMerchantSearch
} from '../../models/EvoSalesPortalModel';
import { MediatorServiceBase } from './mediator-base.service';

@Injectable()
export class MerchantSearchMediatorService
	extends MediatorServiceBase<IMerchantSearch, MerchantSearch>
	implements Resolve<MerchantSearch> {
	constructor(@Inject('SESSION_STORAGE') protected sessionStorage: Storage) {
		// alert('MerchantSearchMediatorService ctor.');
		super(sessionStorage, 'msid');
	}

	create(ob: IMerchantSearch): MerchantSearch {
		const result = new MerchantSearch(ob);
		return result;
	}
}
